import React, { useState, useEffect } from "react";
import { object, array, string, bool } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import CardImage from "../../atoms/CardImage";
import StoryMetaData from "../StoryMetaData";

import { getExcerpt, getStoryHeadline } from "../../utils/utils";

import "./wideStoryCard.m.css";

const WideStoryCard = ({
  story,
  widths = [650],
  aspectRatio = [16, 9],
  imageType = "image16x9",
  publisherAttributes,
  updatedFont = false,
  src = "",
  isCommentedStory = false
}) => {
  const excerpt = getExcerpt(story);
  const [isMobile, setIsMobile] = useState(true);
  const storyHeadlineStyle = updatedFont ? `${publisherAttributes.lang}-story-headline` : "";
  const storyExcerptStyle = updatedFont ? `${publisherAttributes.lang}-story-excerpt` : "";
  const customStoryHeadlineStyle = updatedFont && src ? `${publisherAttributes.lang}-story-headline-${src}` : "";
  const headlineStyle = src ? customStoryHeadlineStyle : storyHeadlineStyle;
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;
  const storyHeadline = getStoryHeadline(story);

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
  }, []);

  return (
    <div styleName={`base ${publisherAttributes.lang === "en" ? "en-base" : ""}`} className="wide-story-card">
      <Link href={story.url}>
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={widths}
          showAlternateImage={true}
          isCommentedStory={isCommentedStory}
        />
      </Link>
      <div styleName="story-data" className="story-data">
        {isMobile && story.subheadline && (
          <Link href={story.url}>
            <Headline
              headerLevel={3}
              text={story.subheadline}
              className="story-subheadline"
              styleName={subHeadlineStyle}
            />
          </Link>
        )}
        {storyHeadline && (
          <Link href={story.url}>
            <Headline
              text={storyHeadline}
              headlineType={11}
              headerLevel={2}
              className="story-headline"
              styleName={headlineStyle}
            />
          </Link>
        )}
        {excerpt ? (
          <Link href={story.url}>
            <Headline
              text={excerpt}
              headerLevel={4}
              headlineType={6}
              className="story-excerpt"
              styleName={storyExcerptStyle}
            />
          </Link>
        ) : null}
        <StoryMetaData story={story} src={src} updatedFont={updatedFont} publisherLang={publisherAttributes.lang} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

WideStoryCard.propTypes = {
  story: object.isRequired,
  widths: array,
  imageType: string,
  aspectRatio: array,
  publisherAttributes: object,
  updatedFont: bool,
  src: string,
  isCommentedStory: bool
};

export default connect(mapStateToProps, null)(WideStoryCard);
